"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var type_function_1 = require("../../../core/lang/type-function");
var define_component_1 = require("../function/define-component");
exports.component = function (optionsOrElementFunction, functionalName) {
    if (optionsOrElementFunction === void 0) { optionsOrElementFunction = undefined; }
    // functional use: component((scope) => { ... }, ...)
    if (typeof optionsOrElementFunction == type_function_1.TYPE_FUNCTION) {
        optionsOrElementFunction.functionalName = functionalName;
        // component(() => <div></div>, () => ({ div: { color: red } }), 'open')
        return define_component_1.defineComponent(optionsOrElementFunction);
    }
    else {
        // decorator use on class @component({ ... })
        return function (targetClass) {
            if (process.env.NODE_ENV === "development") {
                if (!(new (Object.getPrototypeOf(targetClass).prototype.constructor) instanceof core_1.st.component)) {
                    throw new Error("@component class " + targetClass.name + " doesn't extend base class st.component. Make sure to write: class " + targetClass.name + " extends st.component implements ILifecycle { ... your implementation ... }");
                }
            }
            return define_component_1.defineComponent(targetClass, optionsOrElementFunction);
        };
    }
};
//# sourceMappingURL=component.js.map